import defaultState from './default';
import active from './active';
import hover from './hover';
import disabled from './disabled';

export default {
  default: defaultState,
  active,
  hover,
  disabled,
};
